import React, { useEffect, useState, useRef, useContext } from "react"
import { ButtonGroup, Col, Form, Row, Tab, Tabs } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import DatePicker from "react-datepicker"
import toast from "react-hot-toast"
import Select from "react-select"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/Table"
import AddModal from "./Components/AddPIModal"
import DeleteModal from "../../../Components/Modals/DeleteModal"
import downloadIcon from "../../../Assets/Images/download_icon.png"
import * as XLSX from "xlsx"

import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi"
import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi"
import {
  createBir2037ExpensesInvoice,
  deleteSuppliesInvoice,
  filterSEInvoice,
} from "../../../Helpers/apiCalls/Expenses/suppliesInvoiceApi"
import {
  getTodayDate,
  isAdmin,
  refreshPage,
  toastStyle,
  TokenExpiry,
  numberFormat,
  selectDropdownStyle,
} from "../../../Helpers/Utils/Common"
import "./PurchaseInvoices.css"
import Moment from "moment"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import GenerateBirModal from "../../Purchases/PurchaseOrders/Components/GenerateBirModal"
import BirForm from "../../Purchases/Pay Suppliers/Components/BirForm"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"

export default function PurchaseInvoices() {
  let navigate = useNavigate()
  const [inactive, setInactive] = useState(true)
  const [suppliers, setSuppliers] = useState([])
  const [sePiManager, setSePiManager] = useState([])
  const [showLoader, setShowLoader] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [excelData, setExcelData] = useState([])
  const [showGenerateBirModal, setShowGenerateBirModal] = useState(false)
  const handleShowGenerateBirModal = () => setShowGenerateBirModal(true)
  const handleCloseGenerateBirModal = () => setShowGenerateBirModal(false)
  const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
    useContext(Context)

  const xlsxHeaders = [
    "DATE",
    "SUPPLIER",
    "INV NO.",
    "DR NO.",
    "SUBTOTAL",
    "AMOUNT DUE",
    "AMT PAID",
    "BAL",
    "PMT STATS",
    "PMT REF NO",
    "SE NO.",
    "BRANCH",
    "PREP BY",
  ]

  const twoweeksago = new Date()
  twoweeksago.setDate(twoweeksago.getDate() - 14)
  const [filterConfig, setFilterConfig] = useState({
    status: currentTab || "open",
    supplier: "",
    bank: "",
    invoice_no: "",
    date_from: dateFilter.date_from ? dateFilter.date_from : "",
    date_to: dateFilter.date_to ? dateFilter.date_to : "",
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  const [grandTotal, setGrandTotal] = useState(0)
  const [totalPaidAmount, setTotalPaidAmount] = useState(0)
  const [totalBalance, setTotalBalance] = useState(0)

  function handleFilterChange(e) {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return { ...prev, [name]: value }
    })
  }

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    setCurrentTab(tabKey)
    setFilterConfig((prev) => {
      return {
        ...prev,
        status: tabKey,
        supplier_id: "",
        vendor_id: "",
        date_from: dateFilter.date_from || "",
        date_to: dateFilter.date_to || "",
        page: 1,
      }
    })
  }

  useEffect(() => {
    fetchPI()
  }, [filterConfig, currentPage])

  async function fetchPI() {
    setShowLoader(true)
    setSePiManager([])
    setGrandTotal("0")
    setTotalPaidAmount("0")
    setTotalBalance("0")
    setTotalItems(0)

    const response = await filterSEInvoice(filterConfig)
    if (response.error) {
      TokenExpiry(response.error)
    } else {
      var allBills = response.data.data.map((invoice) => {
        var info = invoice
        info.supplier_vendor = info.supplier_id
          ? info.supplier_name || info.supplier_trade_name
          : info.vendor_id
          ? info.vendor_name || info.vendor_trade_name
          : "N/A"
        info.se_id = invoice.supplies_expense_id
        info.supplies_receive_date = invoice.supplies_receive_date
          ? Moment(invoice.supplies_receive_date).format("MMM DD, YYYY")
          : "(Invalid)"
        info.total = numberFormat(invoice.grand_total)
        info.discounted_subtotal = numberFormat(invoice.discounted_subtotal)
        info.amount_paid = numberFormat(invoice.paid_amount)
        info.balance = numberFormat(info.balance)
        info.pay_ref_no = !invoice.payments
          ? ""
          : invoice.payments
              .map((data) => {
                return data.doc_no
              })
              .join(", ")
        return info
      })

      var grandtotal = response.data.summary ? response.data.summary.total : "0"
      var totalpaid = response.data.summary
        ? response.data.summary.total_paid
        : "0"
      var totalbalance = response.data.summary
        ? response.data.summary.total_balance
        : "0"
      setGrandTotal(grandtotal)
      setTotalPaidAmount(totalpaid)
      setTotalBalance(totalbalance)

      setSePiManager(
        allBills
          .sort(
            (a, b) =>
              new Date(...a.supplies_receive_date?.split("/").reverse()) -
              new Date(...b.supplies_receive_date?.split("/").reverse())
          )
          .reverse()
      )

      var data = allBills
        .sort(
          (a, b) =>
            new Date(...a.supplies_receive_date?.split("/").reverse()) -
            new Date(...b.supplies_receive_date?.split("/").reverse())
        )
        .reverse()
      var excel = data.map((bill) => {
        var info = {}
        info.supplies_receive_date = bill.supplies_receive_date
        info.supplier_vendor = bill.supplier_vendor
        info.invoice_no = bill.invoice_no
        info.dr_no = bill.dr_no
        info.discounted_subtotal = bill.discounted_subtotal
        info.total = bill.total
        info.amount_paid = bill.amount_paid
        info.balance = bill.balance
        info.payment_status = bill.payment_status
        info.pay_ref_no = bill.pay_ref_no
        info.se_id = bill.se_id
        info.branch_name = bill.branch_name
        info.prepared_by = bill.prepared_by
        return info
      })
      setExcelData(excel)
      setTotalItems(response.data.size)
    }
    setShowLoader(false)
  }

  function handleExport() {
    const rows = excelData

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1")
    if (filterConfig.status === "open") {
      XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
      XLSX.writeFile(workbook, "OpenSuppliesInvoice.xlsx", {
        compression: true,
      })
    } else if (filterConfig.status === "") {
      XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
      XLSX.writeFile(workbook, "AllSuppliesInvoice.xlsx", { compression: true })
    } else if (filterConfig.status === "close") {
      XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" })
      XLSX.writeFile(workbook, "ClosedSuppliesInvoice.xlsx", {
        compression: true,
      })
    }
  }

  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)
  const [PIID, setPIID] = useState("")

  async function handleDeletePI() {
    setIsClicked(true)
    const response = await deleteSuppliesInvoice(PIID)

    if (response.data) {
      toast.success("Supplies Invoice Deleted Successfully!", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      toast.error("Error Deleting Supplies Invoice", {
        style: toastStyle(),
      })
    }
  }

  const [showAddModal, setShowAddModal] = useState(false)
  const handleShowAddModal = () => setShowAddModal(true)
  const handleCloseAddModal = () => setShowAddModal(false)

  function handleSelectChange(e, id) {
    if (e.target.value === "edit-pi") {
      navigate("edit/" + id)
    } else if (e.target.value === "print-pi") {
      navigate("/se/purchaseinvoices/print/" + id)
    } else if (e.target.value === "pay-pi") {
      navigate("pay-check")
    } else if (e.target.value === "delete-pi") {
      setPIID(id)
      handleShowDeleteModal()
    } else if (e.target.value === "generate-bir") {
      setPIID(id)
      handleShowGenerateBirModal()
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row.id)}
      >
        <option value="" hidden selected>
          Select
        </option>
        {/* {isAdmin ? (
          <option value="edit-pi" className="color-options">
            Edit
          </option>
        ) : null} */}
        <option value="print-pi" className="color-options">
          View
        </option>
        <option value="generate-bir" className="color-options">
          Generate BIR 2307
        </option>
        {isAdmin && (
          <option value="delete-pi" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }

  function ViewPIBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.id)}
        value="print-pi"
      >
        View
      </button>
    )
  }

  // async function handleGenerateBir2037() {
  //   setIsClicked(true)

  //   // yet to be changed
  //   var response = await createBir2037ExpensesInvoice(PIID)
  //   if (response.data) {
  //     //extract data from response and then feed to excel
  //     toast.success("BIR 2037 generated successfully", {
  //       style: toastStyle(),
  //     })
  //     handleCloseGenerateBirModal()
  //     // setTimeout(() => refreshPage(), 1000)
  //     // handleExcelGeneration(response)
  //     //after a successfull generation close modal
  //   } else {
  //     response.error?.response?.data?.messages.map((data) => {
  //       return toast.error(data)
  //     })
  //     // setTimeout(() => refreshPage(), 1000);
  //   }
  //   setIsClicked(false)
  // }

  async function handleGenerateBir2037() {
    setIsClicked(true)
    toast.loading("Printing Form 2307", { style: toastStyle() })
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  function ContractBtn(row) {
    return (
      <ButtonGroup vertical>
        <>
          {row.payments?.map((row) => {
            return (
              <button
                type="button"
                className="button-secondary table-button me-3"
                onClick={() => handleViewContract(row.id, row.payment_mode)}
              >
                {row.doc_no}
              </button>
            )
          })}
        </>
      </ButtonGroup>
    )
  }
  function handleViewContract(id, payment_mode) {
    window.open("/se/paysuppliers/view/" + id + "/" + payment_mode, "_blank")
  }

  const [supplierList, setSupplierList] = useState([])
  const [selectedSupplier, setSelectedSupplier] = useState("")

  useEffect(() => {
    setSupplierList(
      suppliers.map((supplier) => {
        return {
          label: supplier.trade_name,
          value: supplier.id + "|" + supplier.type,
        }
      })
    )
    setSupplierList((branches) => {
      var newBranches = [...branches]
      newBranches.push({ label: "All Suppliers", value: "" })
      return newBranches.reverse()
    })
  }, [suppliers])

  function handleSupplierChange(e) {
    setSelectedSupplier(e.name)
    const toFilter = { target: { name: "supplier", value: e.value } }
    handleFilterChange(toFilter)
  }

  async function fetchSuppliers() {
    setShowLoader(true)

    const response = await getAllSuppliers()
    var allData = []

    if (response.error) {
      TokenExpiry(response.error)
    } else {
      response.data.data.map((supplier) => {
        var info = supplier
        info.type = "supplier"
        allData.push(info)
      })
    }
    setSuppliers(allData)
    setShowLoader(false)
  }

  useEffect(() => {
    fetchPI()
    fetchSuppliers()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SUPPLIES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              EXPENSE PURCHASE INVOICE
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="invoice_no"
              placeholder="Search Invoice No/DR no.."
              className="search-bar"
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
            />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <button className="add-btn" onClick={handleShowAddModal}>
                Add
              </button>
            </div>
          </Col>
        </Row>

        <Tabs
          activeKey={filterConfig.status}
          defaultActiveKey={filterConfig.status}
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="open" title="Open Bills" className="sePI-tab-wrapper">
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={supplierList}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_from}
                  name="date_from"
                  placeholderText={"Select Date From"}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_to}
                  name="date_to"
                  placeholderText={"Select Date To"}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  fixedHeight
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                  minDate={filterConfig.date_from ? filterConfig.date_from : ""}
                />
              </Col>
            </Row>
            <div className="mb-2" />

            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due: {numberFormat(grandTotal)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Paid Amount: {numberFormat(totalPaidAmount)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Balance: {numberFormat(totalBalance)}
              </span>
            </div>

            <div className="sePI-tbl ">
              {
                <TableWithDynamicPagination
                  tableHeaders={[
                    "-",
                    "DATE",
                    "SUPPLIER",
                    "INV NO.",
                    "DR NO.",
                    "SUBTOTAL",
                    "AMOUNT DUE",
                    "AMT PAID",
                    "BAL",
                    "PMT STATS",
                    "PMT REF NO",
                    "SE NO.",
                    "BRANCH",
                    "PREP BY",
                    "ACTIONS",
                  ]}
                  headerSelector={[
                    "-",
                    "supplies_receive_date",
                    "supplier_vendor",
                    "invoice_no",
                    "dr_no",
                    "discounted_subtotal",
                    "total",
                    "amount_paid",
                    "balance",
                    "payment_status",
                    "pay_ref_no",
                    "se_id",
                    "branch_name",
                    "prepared_by",
                  ]}
                  tableData={sePiManager}
                  ActionBtn={(row) => ActionBtn(row, "open")}
                  ViewBtn={(row) => ViewPIBtn(row)}
                  newTabBtn={(row) => ContractBtn(row)}
                  showLoader={showLoader}
                  // used in dynamic pagination
                  totalItems={totalItems}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  handlePageChange={handlePageChange}
                />
              }
            </div>
            <div className="mb-2" />
          </Tab>

          <Tab
            eventKey="close"
            title="Closed Bills"
            className="sePI-tab-wrapper"
          >
            {/* filters */}

            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={supplierList}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_from}
                  name="date_from"
                  placeholderText={"Select Date From"}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_to}
                  name="date_to"
                  placeholderText={"Select Date To"}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  fixedHeight
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                  minDate={filterConfig.date_from ? filterConfig.date_from : ""}
                />
              </Col>
            </Row>
            <div className="mb-2" />

            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due: {numberFormat(grandTotal)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Paid Amount: {numberFormat(totalPaidAmount)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Balance: {numberFormat(totalBalance)}
              </span>
            </div>

            <div className="">
              <TableWithDynamicPagination
                tableHeaders={[
                  "-",
                  "DATE",
                  "SUPPLIER",
                  "INV NO.",
                  "DR NO.",
                  "SUBTOTAL",
                  "AMOUNT DUE",
                  "AMT PAID",
                  "BAL",
                  "PMT STATS",
                  "PMT REF NO",
                  "SE NO.",
                  "BRANCH",
                  "PREP BY",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "-",
                  "supplies_receive_date",
                  "supplier_vendor",
                  "invoice_no",
                  "dr_no",
                  "discounted_subtotal",
                  "total",
                  "amount_paid",
                  "balance",
                  "payment_status",
                  "pay_ref_no",
                  "se_id",
                  "branch_name",
                  "prepared_by",
                ]}
                tableData={sePiManager}
                ActionBtn={(row) => ActionBtn(row, "closed")}
                ViewBtn={(row) => ViewPIBtn(row)}
                showLoader={showLoader}
                newTabBtn={(row) => ContractBtn(row)}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="all" title="All" className="sePI-tab-wrapper">
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={supplierList}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_from}
                  name="date_from"
                  placeholderText={"Select Date From"}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_from: date }
                    })
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.date_to}
                  name="date_to"
                  placeholderText={"Select Date To"}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, date_to: date }
                    })
                  }}
                  fixedHeight
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                  minDate={filterConfig.date_from ? filterConfig.date_from : ""}
                />
              </Col>
            </Row>
            <div className="mb-2" />

            <div className=" PO-filters d-flex justify-content-center">
              <span className="me-4 ml-4 mt-2 ps-label">
                Grand Amount Due: {numberFormat(grandTotal)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Paid Amount: {numberFormat(totalPaidAmount)}
              </span>

              <span className="me-4 ml-4 mt-2 ps-label">
                Total Balance: {numberFormat(totalBalance)}
              </span>
            </div>

            <div className="sePI-tbl ">
              {
                <TableWithDynamicPagination
                  tableHeaders={[
                    "-",
                    "DATE",
                    "SUPPLIER",
                    "INV NO.",
                    "DR NO.",
                    "SUBTOTAL",
                    "AMOUNT DUE",
                    "AMT PAID",
                    "BAL",
                    "PMT STATS",
                    "PMT REF NO",
                    "SE NO.",
                    "BRANCH",
                    "PREP BY",
                    "ACTIONS",
                  ]}
                  headerSelector={[
                    "-",
                    "supplies_receive_date",
                    "supplier_vendor",
                    "invoice_no",
                    "dr_no",
                    "discounted_subtotal",
                    "total",
                    "amount_paid",
                    "balance",
                    "payment_status",
                    "pay_ref_no",
                    "se_id",
                    "branch_name",
                    "prepared_by",
                  ]}
                  tableData={sePiManager}
                  ActionBtn={(row) => ActionBtn(row, "open")}
                  ViewBtn={(row) => ViewPIBtn(row)}
                  newTabBtn={(row) => ContractBtn(row)}
                  showLoader={showLoader}
                  // used in dynamic pagination
                  totalItems={totalItems}
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  handlePageChange={handlePageChange}
                />
              }
            </div>
            <div className="mb-2" />
          </Tab>
        </Tabs>
        <Row className="mt-3">
          <Col xs={12} lg={10}></Col>
          <Col lg={2} className="mt-2 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img
                    alt="download"
                    width={20}
                    height={20}
                    src={downloadIcon}
                  ></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <br />
        <br />
      </div>
      <DeleteModal
        show={showDeleteModal}
        onHide={() => handleCloseDeleteModal()}
        text="purchase invoice"
        onDelete={() => handleDeletePI()}
        isClicked={isClicked}
      />
      <AddModal show={showAddModal} hide={handleCloseAddModal} />
      <GenerateBirModal
        show={showGenerateBirModal}
        hide={() => handleCloseGenerateBirModal()}
        message="Are you sure you want to Generate BIR 2307 for this purchase invoice?"
        handler={() => handleGenerateBir2037()}
        isClicked={isClicked}
      />
      <Footer />
      <BirForm id={PIID} type="supplies-receive" />
    </div>
  )
}
